import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobEditCompensationPage from '@/features/jobs/job-edit-compensation/JobEditCompensationPage';

export const jobEditCompensationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar/remuneracao',
  component: JobEditCompensationPage,
});
